import React from 'react'
import {
  Drawer,
  DrawerBody,
  DrawerHeader as ChakraDrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerFooter
} from '@chakra-ui/react'
import { Link } from 'chemistry'
import DrawerHeader from '../DrawerHeader/DrawerHeader'
import ProductsGrid from '../../../../common/components/grid/ProductsGrid'

const CategoryDrawer = ({ format, lang, isOpen, setIsOpen, data, contentfulTranslations }) => {
  return (
    <Drawer placement='right' onClose={() => setIsOpen(false)} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent
        className='buyListDrawer'
        sx={{
          maxWidth: {
            base: '100%',
            sm: '475px'
          },
          header: {
            borderBottom: '1px solid var(--chakra-colors-gray-100)'
          },
          footer: {
            borderTop: '1px solid var(--chakra-colors-gray-100)'
          },
          '> *': {
            p: '24px'
          },
          '> div': {
            pt: '32px'
          }
        }}
      >
        <ChakraDrawerHeader>
          <DrawerHeader
            title={data?.category?.title || data?.products?.collection?.[0]?.title}
            onClose={() => setIsOpen(false)}
          />
        </ChakraDrawerHeader>
        <DrawerBody>
          <div className='products-grid-wrapper'>
            <ProductsGrid
              {...{
                sizes: ['sm'],
                format,
                lang,
                collection: data?.products?.collection,
                meta: data?.meta,
                cardsInRow: 1,
                target: '_blank',
                withArrow: true
              }}
            />
          </div>
        </DrawerBody>
        {!!data?.category?.id && (
          <DrawerFooter
            sx={{
              a: {
                w: '100%'
              }
            }}
          >
            <Link variant='primary' href={`/c/${data.category.id}`} target='_blank'>
              {contentfulTranslations.viewAllProducts}
            </Link>
          </DrawerFooter>
        )}
      </DrawerContent>
    </Drawer>
  )
}

export default CategoryDrawer
